/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - create mock tests for cookies unit tests
*/
import { isJson } from 'root/utils/json/isJson';
class CookieMonster {
    readonly #useDomain: boolean;

    constructor({ useDomain = false }: { useDomain?: boolean } = {}) {
        this.#useDomain = useDomain;
    }

    setCookie(name: string, value: string, days?: number) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }

        let domainAttr = '';
        if (this.#useDomain) {
            const isProduction =
                window.location.hostname.includes('www.lightspeedhq.com');
            const debugDomain = new URLSearchParams(window.location.search).has(
                'debug_cookie_domain'
            );

            domainAttr = isProduction || debugDomain ? '; domain=lightspeedhq.com' : '';
        }
        document.cookie = `${name}=${value}${expires}; path=/${domainAttr}`;
    }
    getRawCookie(name: string) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.includes(nameEQ)) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    }
    getCookie(name: string) {
        const rc = this.getRawCookie(name);
        if (rc === null) return null;
        return isJson.check(rc) ? JSON.parse(rc) : rc;
    }
    unsetCookie(name: string) {
        this.setCookie(name, '', -1);
    }
}

export { CookieMonster };
